module.exports = __webpack_public_path__ + "img/plastic-card.b683fd51.png";